import { cities } from './cities';

export const data = {
    cities: Object.values(cities).map((city) => ({
        ...city,
        chart_data: city.chart_data.map((annualReport) => ({
            ...annualReport,
            // it is easier to add 1 year here than update 400+ year fields in the json files
            year: annualReport.year + 1,
        })),
    })),
    sorting: {
        speciality: [
            {
                title: 'Total',
                value: 'total',
                accentColor: 'pink',
            },
            {
                title: 'Creative',
                value: 'creative',
                accentColor: 'blue',
            },
            {
                title: 'Technical',
                value: 'technical',
                accentColor: 'yellow',
            },
            {
                title: 'Professional',
                value: 'professional',
                accentColor: 'green',
            },
        ],
        category: [
            {
                title: 'Population',
                value: 'population',
            },
            {
                title: 'Revenue',
                value: 'revenue',
            },
        ],
    },
    currency: 'USD',
    currency_symbol: '$',
};
